import script from "./LeaderProjectInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectInfo.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectInfo.vue?vue&type=style&index=0&id=98b6e43a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98b6e43a"]])

export default __exports__